import React from 'react'

const Tips = () => {
  return (
    <div>
      <h1>This is tips page</h1>
    </div>
  )
}

export default Tips
